import type { ColDef } from 'ag-grid-community';

export const checkboxColumn: ColDef = {
  field: 'checkbox',
  headerName: '',
  pinned: 'left',
  lockPinned: true,
  lockPosition: true,
  initialWidth: 40,
  resizable: false,
  sortable: false,
  editable: false,
  checkboxSelection: true,
  cellStyle: { borderColor: 'transparent !important' },
};
